export default {
  statuses: {
    ACTIVE: 0,
    ARCHIVED: 1
  },
  typeText: {
    0: 'System',
    1: 'Affiliate',
    2: 'Partner'
  },
  type: {
    SYSTEM: 0,
    AFFILIATE: 1,
    PARTNER: 2
  },
  promoCodeCookieName: 'promo_code_1'
}



// WEBPACK FOOTER //
// ./src/store/coupon/state.js